<template>
  <div>
    <hia-loading v-if="fetchingSpecialties"></hia-loading>
    <div id="heightplaceholder" v-if="fetchingSpecialties" style="min-height: 557px;"></div>
    <template v-if="!fetchingSpecialties">
      <template v-if="showAddRow()">
        <h4 class="heading">Set Coders, Specialties and Dates and choose Add Coders
        </h4>

        <el-form label-position="top" ref="addCodersForm" @submit.prevent.native :model="addRow" :rules="addRow.rules">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="numberOfCoders" label="Number of Coders" style="width: 90%;">
                <el-input-number v-model="addRow.numberOfCoders" :min="1" :max="25"></el-input-number>
              </el-form-item>
              <el-form-item prop="specialties" label="Specialties" style="width: 90%;">
                <el-button style="margin-bottom: 20px;" icon="el-icon-plus" plain @click="openSpecialtiesModal(addRow)">
                  Add/Update Specialties
                </el-button>
                <el-table id="addrowSpecialties" empty-text="No Specialties Selected" :data="addRow.specialties.filter(x => x.selected)" :show-header="false"
                  style="max-width: 300px;">
                  <el-table-column width="150">
                    <template slot-scope="scope">
                      {{scope.row.key}}
                    </template>
                  </el-table-column>
                  <el-table-column>
                    <template slot-scope="scope">
                      {{getCodingDetailsText(scope.row)}}
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="scheduledDays" :label="`Select Scheduled Days`">
                <CalendarPicker class="coderCalendar" style="margin: 0" v-model="addRow.scheduledDays" :pageDate="startDate">
                </CalendarPicker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="margin-top: 20px;">
          <el-button id="addCoders" plain @click="addCoders"><i class="mdi mdi-account-multiple-plus coderIcon"></i>Add
            Coders</el-button>
        </div>
      </template>
      <template v-else>
        <el-alert title="Request Period Locked, please contact HIA for any changes" type="warning" :closable="false">
        </el-alert>
      </template>
      <h4 class="heading top-margin-30">
        {{`Coder Details - ${coders.length} ${coders.length === 1 ? 'Coder' : 'Coders'} Requested`}}
        <el-button-group style="float: right; position: relative; bottom: 10px;">
          <el-button :disabled="coders.length === 0 || !showAddRow() || preventZeroCoders" id="clearCoders" plain @click="clearCoders"
            style="border-top-right-radius: 0px !important; border-bottom-right-radius: 0px !important"><i class="mdi mdi-account-multiple-minus coderIcon"></i>Clear Coders
          </el-button>
          <el-button :disabled="coders.length === 0" id="clearCoders" plain @click="showMasterCalendarDialog = true"
            style="border-top-left-radius: 0px !important; border-bottom-left-radius: 0px !important"><i class="el-icon-date coderIcon" style="font-size: 16px;"></i>Master
            Calendar</el-button>
        </el-button-group>
      </h4>
      <div>
        <el-table v-loading="loading" id="editCodersTable" ref="editCodersTable" class="top-margin" :data="coders" empty-text="No Coders Added Yet">
          <el-table-column prop="" label="" width="35">
            <template slot-scope="scope">
              <i v-if="showAddRow() && !(preventZeroCoders && coders.length <= 1)" class="el-icon-close showOnHover" @click="deleteCoder(scope.row)"></i>
            </template>
          </el-table-column>
          <el-table-column prop="coder" label="Coder" width="120">
          </el-table-column>
          <el-table-column prop="specialties" label="Specialties">
            <template slot-scope="scope">
              <div style="display: table-row">
                <ul class="table-list">
                  <li v-for="specialty in scope.row.specialties.filter(x => x.selected)" :key="specialty.key">
                    {{specialty.key}} - {{getCodingDetailsText(specialty)}}</li>
                </ul>
                <i v-if="showAddRow()" style="display: table-cell; vertical-align: middle; padding-left: 10px;" class="mdi mdi-square-edit-outline table-icon-button"
                  @click="openSpecialtiesModal(scope.row)"></i>
              </div>
              <CodingRequestProSpecialtiesModal :specialties="scope.row.specialties.filter(x => x.key !== 'By Coder')" :showSpecialtiesModal="scope.row.showSpecialtiesModal"
                :getCodingDetailsText="getCodingDetailsText" @apply="saveAndCloseSpecialtiesModal(scope.row)" @cancel="cancelSpecialtiesModalSave(scope.row)">
              </CodingRequestProSpecialtiesModal>
            </template>
          </el-table-column>
          <el-table-column prop="scheduledDays" label="Scheduled Days" width="120">
            <template slot-scope="scope">
              <span>{{scope.row.scheduledDays.length}}
                {{ scope.row.scheduledDays.length === 1 ? 'Day' : 'Days' }}</span>
              <i class="el-icon-date table-icon-button" @click="openCalendar(scope.row)"></i>
              <el-dialog :title="scope.row.coder" class="calendar-modal" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false"
                :visible.sync="scope.row.showCalendar" width="100">
                <CalendarPicker v-model="scope.row.scheduledDays" :pageDate="startDate" @change="handleCalendarChange(scope.row)">
                </CalendarPicker>
                <el-alert style="margin-top: 20px;" type="warning" v-if="calendarModalMessage" :closable="false">
                  {{calendarModalMessage}}</el-alert>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="cancelCalendarSave(scope.row)">Cancel</el-button>
                  <el-button :disabled="scope.row.calendarSaveDisabled" type="primary" @click="saveAndCloseCalendar(scope.row)">
                    Apply</el-button>
                </span>
              </el-dialog>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <CodingRequestProSpecialtiesModal :specialties="addRow.specialties.filter(x => x.key !== 'By Coder')" :showSpecialtiesModal="addRow.showSpecialtiesModal"
        :getCodingDetailsText="getCodingDetailsText" @cancel="cancelSpecialtiesModalSave(addRow)" @apply="addRow.showSpecialtiesModal = false">
      </CodingRequestProSpecialtiesModal>

      <el-dialog :visible.sync="showMasterCalendarDialog">
        <MasterCalendarPicker :coders="coders" :pageDate="startDate">
        </MasterCalendarPicker>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showMasterCalendarDialog = false">Close</el-button>
        </span>
      </el-dialog>

    </template>
  </div>
</template>

<script>
  import { differenceInCalendarDays } from 'date-fns'
  import CalendarPicker from '@/components/CalendarPicker/CalendarPicker'
  import CodingRequestProSpecialtiesModal from './CodingRequestProSpecialtiesModal'
  import MasterCalendarPicker from '@/components/CalendarPicker/MasterCalendarPicker'
  import { mapState, mapActions } from 'vuex'

  export default {
    props: {
      startDate: {
        type: Date,
        required: true
      },
      coders: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean
      },
      preventZeroCoders: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {
        scheduledDaysBackup: [],
        patientTypesTracker: [],
        calendarModalMessage: '',
        showCodingDetails: false,
        showMasterCalendarDialog: false,
        fetchingSpecialties: false,
        specialtiesBackup: [],
        addRow: {
          numberOfCoders: 1,
          codingTypes: [],
          scheduledDays: [],
          specialties: [],
          showSpecialtiesModal: false,
          rules: {
            codingTypes: [
              { required: true, message: 'Please Select Coding Types', trigger: 'change' }
            ],
            specialties: [
              {
                required: true,
                validator: (rule, value, callback) => {
                  if (this.selectedSpecialties.length > 0) {
                    callback()
                  } else {
                    callback(new Error('Please Add Specialties'))
                  }
                },
                trigger: 'change'
              }
            ],
            scheduledDays: [
              { required: true, message: 'Please Select Scheduled Days', trigger: 'change' }
            ],
            numberOfCoders: [
              { required: true, message: 'Please Set Number of Coders', trigger: 'change' }
            ]
          }
        }
      }
    },
    name: 'CodingRequestProCoderDetails',
    methods: {
      ...mapActions('requests/', ['GET_SPECIALTIES']),
      addCoders() {
        this.$refs['addCodersForm'].validate((valid) => {
          if (valid) {
            let newCoders = []

            let maxCoderNumber = 0
            if (this.coders && this.coders.length > 0) {
              maxCoderNumber = Math.max.apply(Math, this.coders.map((x) => { return x.coderNumber }))
            }

            for (let i = 0; i < this.addRow.numberOfCoders; i++) {
              let l = this.coders.length
              newCoders.push({
                coder: `Coder #${l + i + 1}`,
                coderNumber: maxCoderNumber + i + 1,
                specialties: JSON.parse(JSON.stringify(this.addRow.specialties)),
                scheduledDays: this.addRow.scheduledDays.slice(), // copy
                showCalendar: false,
                calendarSaveDisabled: true,
                showSpecialtiesModal: false
              })
            }
            this.$emit('add', newCoders)

            this.addRow.numberOfCoders = 1
            this.addRow.specialties = this.addRow.specialties.map(x => {
              x.isClinic = false
              x.isHospital = false
              x.isDx = false
              x.isEM = false
              x.isSurgCpt = false
              x.selected = false
              return x
            })

            this.addRow.scheduledDays = []
            this.$refs['addCodersForm'].resetFields()
          }
        })
      },
      getCodingDetailsText(row) {
        if (!row.isDx && !row.isEM && !row.isSurgCpt && !row.isHospital && !row.isClinic) {
          return 'Please Set Codes to be Assigned'
        }

        let text = []
        if (row.isDx) {
          text.push('Dx')
        }
        if (row.isEM) {
          text.push('E&M')
        }
        if (row.isSurgCpt) {
          text.push('Surg. Cpt')
        }
        if (row.isHospital) {
          text.push('Hospital')
        }
        if (row.isClinic) {
          text.push('Clinic')
        }
        return text.join(', ')
      },
      deleteCoder(coder) {
        this.$emit('delete', coder)
      },
      getNumberOfWorkingDays() {
        var selectedMonth = this.getSelectedMonth()
        var lastDay = new Date(selectedMonth.year, selectedMonth.month + 1, 0).getDate()
        var workingDays = 0
        for (let i = 1; i <= lastDay; i++) {
          let date = new Date(selectedMonth.year, selectedMonth.month, i)
          if (date.getDay() !== 0 && date.getDay() !== 6) {
            workingDays++
          }
        }
        return workingDays
      },
      openCalendar(row) {
        this.calendarModalMessage = ''
        this.scheduledDaysBackup = row.scheduledDays.slice()
        row.showCalendar = true
      },
      cancelCalendarSave(row) {
        row.scheduledDays = this.scheduledDaysBackup
        row.showCalendar = false
        row.calendarSaveDisabled = true
      },
      handleCalendarChange(row) {
        row.calendarSaveDisabled = false
      },
      saveAndCloseCalendar(row) {
        if (row.scheduledDays.length === 0) {
          this.calendarModalMessage = 'Please select at least one day'
          return
        }

        row.showCalendar = false
        row.calendarSaveDisabled = true
        this.$emit('save', row)
      },
      openSpecialtiesModal(row) {
        this.specialtiesBackup = JSON.parse(JSON.stringify(row.specialties))
        row.showSpecialtiesModal = true
      },
      cancelSpecialtiesModalSave(row) {
        row.specialties = this.specialtiesBackup
        row.showSpecialtiesModal = false
        row.specialtiesSaveDisabled = true
      },
      saveAndCloseSpecialtiesModal(row) {
        row.showSpecialtiesModal = false
        row.specialtiesSaveDisabled = true
        this.$emit('save', row)
      },
      showAddRow() {
        let lastDayOfMonth = new Date(this.startDate.getFullYear(), this.startDate.getMonth() + 1, 0)
        return differenceInCalendarDays(lastDayOfMonth, new Date()) >= 0
      },
      clearCoders() {
        this.$emit('clearCoders')
      },
      setAddRowSpecialties() {
        this.addRow.specialties = this.specialties.map(x => {
          let item = {
            isClinic: false,
            isHospital: false,
            isDx: false,
            isEM: false,
            isSurgCpt: false,
            selected: false,
            key: x.specialty,
            specialtyId: x.id
          }

          return item
        })
      }
    },
    created: function () {
      if (this.specialties.length === 0) {
        this.fetchingSpecialties = true
        this.GET_SPECIALTIES().then(() => {
          this.fetchingSpecialties = false
          this.setAddRowSpecialties()
        })
      } else {
        this.setAddRowSpecialties()
      }
    },
    computed: {
      ...mapState('requests/', ['specialties']),
      selectedSpecialties() {
        return this.addRow.specialties.filter(x => x.selected)
      }
    },
    components: {
      CalendarPicker,
      CodingRequestProSpecialtiesModal,
      MasterCalendarPicker
    }
  }
</script>

<style scoped>
  >>>tr .el-form-item__content,
  >>>tr .el-dialog {
    font-weight: 400;
  }

  >>>.calendar-modal .el-dialog {
    width: 400px !important;
  }

  >>>.calendar-modal .el-dialog__body {
    padding: 20px;
    margin: auto;
    overflow: inherit;
  }

  >>>tr:hover>td i.showOnHover {
    display: block;
    cursor: pointer;
  }

  >>>tr>td i.showOnHover {
    display: none;
  }

  >>>.coderCalendar {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 0px 20px 15px 20px;
  }

  >>>.vdp-datepicker__calendar .cal-cell.selected {
    /* background: #57CCF4; */
    background: rgba(87, 204, 244, .5);

  }

  /* BUTTON ICONS*/
  .coderIcon {
    font-size: 20px;
    float: left;
    height: 12px;
    margin: -3px 5px 0px 0px;
  }

  .requestButtonIcons {
    font-size: 25px;
    float: right;
    margin: -5px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    height: 14px;
    width: 14px;
  }

  .table-icon-button {
    margin: 0px 0px 0px 10px;
    cursor: pointer;
    font-size: 18px;
    height: 19px;
    vertical-align: middle;
  }

  #specialties>>>.el-form-item {
    margin-bottom: 10px;
  }

  .specialties-popover>>>.el-form-item {
    margin-bottom: 5px !important;
  }

  #specialties p {
    line-height: 1;
    margin: 0px 0px 0px 22px;
    max-width: 210px;
    overflow: hidden;
    padding: 2px 1px 2px 1px;
    border-radius: 3px;
    background: rgba(87, 204, 244, .5);
  }

  #addrowSpecialties>>>tr {
    background-color: rgba(87, 204, 244, .5);
  }

  >>>.el-table__empty-block {
    min-height: 39px;
    font-weight: 500;
  }

  >>>.table-list {
    display: table-cell;
    vertical-align: middle;
    list-style-type: none;
    padding: 0px;
  }
</style>
